import { AlertCircle, AlertTriangle, CheckCircle2, Info, Loader2 } from "lucide-react"
import { Toaster as Sonner } from "sonner"
import { QUIET_TOAST_CLASS } from "@/lib/toast-chrome"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ toastOptions, icons, ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      position="bottom-center"
      expand={false}
      closeButton
      offset={24}
      icons={{
        success: <CheckCircle2 />,
        info: <Info />,
        warning: <AlertTriangle />,
        error: <AlertCircle />,
        loading: <Loader2 className="animate-spin" />,
        ...icons,
      }}
      toastOptions={{
        ...toastOptions,
        classNames: {
          ...toastOptions?.classNames,
          toast: [QUIET_TOAST_CLASS, "group toast", toastOptions?.classNames?.toast]
            .filter(Boolean)
            .join(" "),
          description: "group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
